<template>
  <h4 class="modal-title" id="assignaddontitle">REMOVE ADD-ONS</h4>
  <div class="modalbody" v-if="!removalDone">
    <div class="datadiv bottommargin">
      <label class="headerfont"> Select add-ons to remove </label>
      <div class="overflowdiv topmargin">
        <el-table
          id="prodtoassigntable"
          :data="userAddonsList"
          :border="true"
          style="width: 100%"
          :row-style="rowdatastyle"
          @selection-change="handleCurrentChange"
          :show-header="false"
          empty-text="No add-ons to remove"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column min-width="230">
            <template #default="props">
              <div class="prodnamediv">
                <div style="text-align: start">
                  <h6
                    class="font-bold"
                    style="font-size: 14px; line-height: 19.07px"
                  >
                    {{ props.row.productName }}
                  </h6>
                  <label>
                    Version:
                    {{ props.row.majorVersionNumber }}.{{
                      props.row.minorVersionNumber
                    }}
                  </label>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

  <div class="buttonsdiv" v-if="!removalDone">
    <el-button
      id="assignaddonnext"
      round
      class="btnstyle ml-4"
      variant="warning"
      @click="removeSelectedAddons"
      :disabled="!enableNext"
    >
      <i v-if="!enableNext && !showError" class="fa fa-refresh fa-spin"></i>
      Continue
    </el-button>
    <el-button
      id="prodassigncancel"
      round
      variant="outline-dark"
      @click="cancelRemoval"
      class="cancelbtn"
      >Cancel</el-button
    >
  </div>

  <div v-if="removalDone" class="modalbody">
    <div class="font-bold-16" v-if="removeSuccess">
      <div
        v-for="(addon, index) in selectedAddonsList"
        :key="index"
        class="addonlistdiv"
      >
        <label class="font-regular-16 btm-1">
          Add-on "<strong>{{ addon.productName }}</strong
          >" has been removed successfully from the users below:
        </label>
        <div class="userlistdiv">
          <div v-for="(item, index) in successUsers" :key="index">
            <label class="font-regular-16 breaking-words">
              {{ item.userName }}&#44; {{ item.userEmail }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showError">
      <div class="btm-2">Below errors occured for the selected users:</div>

      <div
        v-for="(item, index) in errorsList"
        :key="index"
        class="font-bold-16 btm-1"
      >
        <label class="summarytitle btm-1">User Name: </label>
        <label class="font-bold-16 btm-1">{{ item.errorUser }}</label>
        <div
          v-for="(prod, index) in item.errorProducts"
          :key="index"
          class="font-bold-16 btm-1"
        >
          <label class="summarytitle btm-1">Addons Name: </label>
          <label class="font-bold-16 btm-1">{{ prod.productName }}</label
          ><br />
          <label class="summarytitle btm-1">Version: </label>
          <label class="btm-2">
            {{ prod.majorVersionNumber }}.{{ prod.minorVersionNumber }}
          </label>
        </div>
        <div v-if="showError" style="display: flex" class="maxitems">
          <img
            src="@/assets/icons/warnerror.svg"
            class="cellimage"
            style="margin-top: 10px"
            alt="errorimg"
            title="errorimg"
          />
          <label class="errordiv" style="padding: 1rem 0">
            Error occured during removal of add-ons.</label
          >
        </div>
      </div>
    </div>
    <div class="buttonsdiv">
      <el-button
        round
        class="btnstyle ml-4"
        variant="warning"
        id="prodassingconfirm"
        @click="cancelRemoval"
      >
        Done
      </el-button>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import APIService from "@/utils/APIService";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { UserActionTypes } from "@/store/userstore/UserActionTypes";
import { ProductActionTypes } from "@/store/productstore/ProductActionTypes";
import _ from "lodash";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";

export default defineComponent({
  name: "RemoveAddonsModal",
  components: {},
  computed: {
    ...mapGetters([
      "getUserAddons",
      "getAddonProducts",
      "getSelectedUserids",
      "getSubscriptionData",
      "getUserData",
      "getSearchValue",
      "getCompanyData",
      "getCurrentPage",
    ]),
    userAddonsList(): any {
      return this.getAddonProducts.length === 0
        ? this.getUserAddons
        : this.getAddonProducts;
    },
    selectedUsers(): any {
      return this.getSelectedUserids !== undefined &&
        this.getSelectedUserids.length !== 0
        ? this.getSelectedUserids
        : [this.getUserData.userBucketId];
    },
  },
  data() {
    return {
      headerstyle: {
        "border-bottom": "unset",
        "font-family": "Open Sans, sans-serif",
        "font-weight": "700",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      rowdatastyle: {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "400",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      selectedAddonsList: [] as any[],
      enableNext: false,
      removalDone: false,
      removeSuccess: false,
      showError: false,
      errorsList: [] as any[],
      successUsers: [] as any[],
    };
  },
  methods: {
    handleCurrentChange(selected: any[]) {
      this.selectedAddonsList = selected;
      if (this.selectedAddonsList.length !== 0) this.enableNext = true;
    },
    removeSelectedAddons() {
      this.enableNext = false;
      const apiService = new APIService(this.axios);
      const addonsToRemove = [] as any[];
      const multipleRequestData = [] as any[];
      this.selectedAddonsList.map((addon) =>
        addonsToRemove.push({
          productBucketId: addon.productBucketId,
          major: addon.majorVersionNumber,
          minor: addon.minorVersionNumber,
          patch: addon.patchVersionNumber,
        })
      );
      this.selectedUsers.map((userid: string) => {
        const removeRequest = {
          userBucketId: userid,
          entitlementsToRemove: addonsToRemove,
        } as any;
        multipleRequestData.push(removeRequest);
      });
      apiService
        .removeMultipleSubscriptions(multipleRequestData)
        .then((res) => {
          if (res.areAllSuccessfull) {
            if (this.$route.name === "user") {
              const userDataObj = {
                userBucketIdList: null,
                companyBucketIdList: null,
                searchPhrase: this.getSearchValue,
                companyName: null,
                pageOptions: {
                  skip: this.getCurrentPage - 1,
                  take: 10,
                  sortField: null,
                  sortOrder: null,
                },
              };

              apiService
                .getUsersList(userDataObj)
                .then((resp) => {
                  this.$store.dispatch(UserActionTypes.SET_USERS, resp);
                })
                .catch((error) => {
                  if (error.code === "ECONNABORTED")
                    this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
                });

              if (!_.isEmpty(this.getUserData)) {
                const userDataObj = {
                  userBucketIdList: [this.getUserData.userBucketId],
                  pageOptions: {
                    sortOrder: 0,
                  },
                };
                apiService
                  .getAssignedProdsList(userDataObj)
                  .then((response) => {
                    this.$store.dispatch(
                      UserActionTypes.SET_ASSIGNED_PRODUCTS,
                      response
                    );
                  })
                  .catch((error) => {
                    if (error.code === "ECONNABORTED")
                      this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
                  });
              }
            } else {
              const userDataObj = {
                userBucketIdList: null,
                companyBucketIdList: [this.getCompanyData.companyBucketId],
                searchPhrase: this.getSearchValue,
                companyName: null,
                pageOptions: {
                  skip: 0,
                  take: 10,
                  sortField: null,
                  sortOrder: null,
                },
              };

              apiService
                .getUsersList(userDataObj)
                .then((resp) => {
                  this.$store.dispatch(UserActionTypes.SET_USERS, resp);
                })
                .catch((error) => {
                  if (error.code === "ECONNABORTED")
                    this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
                });

              const subData = {
                Searchphrase: this.getSearchValue,
                productBucketId: this.getSubscriptionData.productBucketId,
                companyBucketId:
                  this.$route.name === "companies"
                    ? this.getCompanyData.companyBucketId
                    : null,
                Major: this.getSubscriptionData.majorVersionNumber,
                Minor: this.getSubscriptionData.minorVersionNumber,
                Patch: this.getSubscriptionData.patchVersionNumber,
                pageOptions: {
                  skip: 0,
                  take: 10,
                  sortField: null,
                  sortOrder: null,
                },
              };
              apiService
                .getAssignedUsersSubList(subData)
                .then((resp) => {
                  this.$store.dispatch(
                    ProductActionTypes.SET_ASSIGNED_USERS,
                    resp
                  );
                })
                .catch((error) => {
                  if (error.code === "ECONNABORTED")
                    this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
                });
              const subInfo = {
                productBucketId: this.getSubscriptionData.productBucketId,
                companyBucketId:
                  this.$route.name === "companies"
                    ? this.getCompanyData.companyBucketId
                    : null,
                majorVersionNumber: this.getSubscriptionData.majorVersionNumber,
                minorVersionNumber: this.getSubscriptionData.minorVersionNumber,
                patchVersionNumber: this.getSubscriptionData.patchVersionNumber,
              };
              apiService
                .getProduct(subInfo)
                .then((prod) => {
                  this.$store.dispatch(
                    FlowActionTypes.SET_SUBSCRIPTION_DATA,
                    prod.items[0]
                  );
                  this.$store.dispatch(
                    FlowActionTypes.SET_ADDON_DATA,
                    prod.items[0].addOns
                  );
                })
                .catch((error) => {
                  if (error.code === "ECONNABORTED")
                    this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
                });
            }
            this.removalDone = true;
            this.removeSuccess = true;
            res.responses.map((responseUser: any) =>
              this.successUsers.push({
                userName: responseUser.userName,
                userEmail: responseUser.userEmail,
              })
            );
            this.enableNext = !this.enableNext;
          } else {
            this.removalDone = true;
            this.showError = true;
            var productError = [] as any[];
            res.responses.map((item: any) => {
              item.removalResponses.map((productInfo: any) => {
                if (!productInfo.success && productInfo.productName === null) {
                  productError = this.selectedAddonsList;
                } else if (
                  !productInfo.success &&
                  productInfo.productName !== null
                )
                  productError.push(productInfo);
              });
              const filteredErrorAddons = Array.from(
                new Map(
                  productError.map((addonItem) => [
                    addonItem.productBucketId,
                    addonItem,
                  ])
                ).values()
              );
              this.errorsList.push({
                errorMessages: item.removalResult.errorMessages.join(". "),
                errorUser: item.userName,
                errorProducts: filteredErrorAddons,
              });
            });
          }
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    cancelRemoval() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEADDON, false);
      if (!this.showError) {
        this.$store.dispatch(FlowActionTypes.SET_ADDON_USERS, []);
        this.$store.dispatch(UserActionTypes.SET_USER_ADDONS, []);
        this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERS, []);
        this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERIDS, []);
        this.$store.dispatch(ProductActionTypes.SET_ADDONS_LIST, []);
      }
    },
  },
});
</script>
